/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import AuthLayout from '../applications/Auth';
import ErrorLayout from '../applications/Error';
import DashboardLayout from '../applications/Main/Main';

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/outlet/daftar-outlet" />
  },
  {
    path: '/login',
    component: AuthLayout,
    routes: [
      createRoute('login'),
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      createRoute('errors/error-401', 'errorpage/Error401'),
      createRoute('errors/error-404', 'errorpage/Error404'),
      createRoute('errors/error-500', 'errorpage/Error500'),
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/confirm',
    component: ErrorLayout,
    routes: [
      createRoute('confirm/account/[id]', 'konfirmasi'),
      createRoute('confirm/timeout', 'konfirmasitimeout'),
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    // writer: [
    //   createRoute('dashboard', 'dashboard/writer'),
    //   createRoute('blog/post'),
    //   createRoute('blog/post/form', 'blog/post/Tambah'),
    //   createRoute('comment', 'writer/index'),
    // ],
    partner: [
      createRoute('sales/job', 'job/sales/index'),
      createRoute('partner/banksetting', 'sales/banksetting'),
      createRoute('partner/withdraw', 'sales/withdraw'),
      createRoute('partner/saldo/riwayat', 'partner/riwayat'),
      createRoute('sales/saldo/view'),
      createRoute('sales/saldo/benefit', 'sales/bonus'),
      createRoute('sales/saldo'),
      createRoute('sales/datareferal'),
      createRoute('dashboard', 'dashboard/partner'),
      createRoute('outlet/daftar-outlet', 'outlet'),

      createRoute('outlet/daftar-outlet/[id]/[tab]', 'outlet/Tambah'),
      createRoute('voucher/pembuatan'),
      createRoute('voucher/pembuatan/form', 'voucher/pembuatan/Tambah'),
      createRoute('voucher/pembuatan/detail', 'voucher/pembuatan/Detail'),
      createRoute('voucher/data'),
      createRoute('voucher/pemakaian'),
      createRoute('voucher/laporan'),
      createRoute('voucher/request'),
      createRoute('voucher/pembuatan/form', 'voucher/pembuatan/Tambah'),
    ],
    sales: [
      // blog
      createRoute('blog/kategori'),
      createRoute('blog/kategori/form', 'blog/kategori/Tambah'),
      createRoute('blog/subkategori', 'blog/sub_kategori'),
      createRoute('blog/subkategori/form', 'blog/sub_kategori/Tambah'),
      createRoute('blog/post'),
      createRoute('blog/post/form', 'blog/post/Tambah'),
      createRoute('blog/review'),
      createRoute('sales/job/reject', 'job/tolak/index'),
      createRoute('sales/job/approve', 'job/terima/index'),
      createRoute('sales/job', 'job/sales/index'),
      createRoute('sales/banksetting'),
      createRoute('sales/withdraw'),
      createRoute('sales/saldo/riwayat', 'sales/riwayat'),
      createRoute('sales/saldo/view'),
      createRoute('sales/saldo/benefit', 'sales/bonus'),
      createRoute('sales/saldo'),
      createRoute('sales/datareferal'),
      createRoute('profil'),
      createRoute('dashboard', 'dashboard/sales'),
      createRoute('progress', 'sales/progress/index'),
      createRoute('progress/kunjungan', 'sales/progress/kunjungan/index'),
      createRoute('progress/trial', 'sales/progress/trial/index'),
      createRoute('progress/followup', 'sales/progress/followup/index'),
      createRoute('progress/aktivasi', 'sales/progress/aktivasi/index'),
      createRoute('sales/progress/detail'),
      createRoute('sales/kunjungan/form', 'sales/kunjungan/Tambah'),
    ],
    writer: [
      createRoute('outlet/analisa_outlet'),
      // ringkasan outlet
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/daftar-outlet', 'outlet'),
      // blog
      createRoute('blog/kategori'),
      createRoute('blog/kategori/form', 'blog/kategori/Tambah'),
      createRoute('blog/subkategori', 'blog/sub_kategori'),
      createRoute('blog/subkategori/form', 'blog/sub_kategori/Tambah'),
      createRoute('blog/post'),
      createRoute('blog/post/form', 'blog/post/Tambah'),
      createRoute('blog/review'),
      createRoute('profil'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      // support
      // createRoute('support/faq'),
      // createRoute('support/faq/form', 'support/faq/Tambah'),
      // createRoute('support/help'),
      // createRoute('support/help/form', 'support/help/Tambah'),
      // createRoute('support/toc'),
      // createRoute('support/privacy', 'support/pp'),
    ],
    marketing: [
      createRoute('promo'),
      createRoute('website/vidio'),
      createRoute('website/vidio/Tambah'),
      createRoute('website/vidio_kategori'),
      createRoute('website/vidio_kategori/Tambah'),
      createRoute('outlet/laporan'),
      createRoute('outlet/analisa_outlet'),
      createRoute('support/help_kategori'),
      createRoute('support/help_kategori/Tambah'),
      createRoute('support/faq'),
      createRoute('support/faq/form', 'support/faq/Tambah'),
      createRoute('support/help'),
      createRoute('support/help/form', 'support/help/Tambah'),
      createRoute('support/toc'),
      createRoute('support/privacy', 'support/pp'),
      createRoute('support/snkref'),
      createRoute('support/snkcustom'),
      createRoute('support/snkrefoutlet'), createRoute('support/snkbetainstruksi'),
      createRoute('support/snkbetapendaftaran'),
      createRoute('support/snkfreeupgrade'), createRoute('spesifikasilangganan/form', 'website/spesifikasilangganan/form'),
      createRoute('spesifikasilangganan', 'website/spesifikasilangganan/index'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      // ringkasan outlet
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/outlet-aktif', 'outlet/pertumbuhan_outlet'),
      createRoute('outlet/daftar-outlet', 'outlet'),
      // blog
      createRoute('blog/kategori'),
      createRoute('blog/kategori/form', 'blog/kategori/Tambah'),
      createRoute('blog/subkategori', 'blog/sub_kategori'),
      createRoute('blog/subkategori/form', 'blog/sub_kategori/Tambah'),
      createRoute('blog/post'),
      createRoute('blog/post/form', 'blog/post/Tambah'),
      createRoute('blog/review'),
      createRoute('broadcast/wa'),
      createRoute('broadcast/template'),
      createRoute('broadcast/template/tambah', 'broadcast/buatTemplate'),
      createRoute('broadcast/wa/tambah', 'broadcast/buatBroadcast'),
      createRoute('broadcast/koneksi'),
      createRoute('broadcast'),
      createRoute('broadcast/form', 'broadcast/Tambah'),
      createRoute('images'),
    ],
    marketing_manager: [
      createRoute('sales_v2'),
      createRoute('sales_v2/Tambah'),
      createRoute('sales_v2/nonaktif'),
      createRoute('sales_v2/riwayat'),
      createRoute('sales_v2/performa'),
      createRoute('sales_v2/detailsales/[id]', 'sales_v2/detailsales'),
      createRoute('sales_v2/detailsales/[id]/[tab]', 'sales_v2/detailsales'),
      createRoute('ringkasan_order', 'order/ringkasan_order/index'),
      createRoute('klaim_prospek'),
      createRoute('promo'),
      createRoute('promo/detail'),
      createRoute('promo/data'),
      createRoute('promo/data/form'),
      createRoute('website/vidio'),
      createRoute('website/vidio/Tambah'),
      createRoute('website/vidio_kategori'),
      createRoute('website/vidio_kategori/Tambah'),
      createRoute('outlet/laporan'),
      createRoute('outlet/analisa_outlet'),
      createRoute('support/help_kategori'),
      createRoute('support/help_kategori/Tambah'),
      createRoute('support/faq'),
      createRoute('support/faq/form', 'support/faq/Tambah'),
      createRoute('support/help'),
      createRoute('support/help/form', 'support/help/Tambah'),
      createRoute('support/toc'),
      createRoute('support/privacy', 'support/pp'),
      createRoute('support/snkref'),
      createRoute('support/snkcustom'),
      createRoute('support/snkrefoutlet'), createRoute('support/snkbetainstruksi'),
      createRoute('support/snkbetapendaftaran'),
      createRoute('support/snkfreeupgrade'), createRoute('spesifikasilangganan/form', 'website/spesifikasilangganan/form'),
      createRoute('spesifikasilangganan', 'website/spesifikasilangganan/index'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      // ringkasan outlet
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/outlet-aktif', 'outlet/pertumbuhan_outlet'),
      createRoute('outlet/daftar-outlet', 'outlet'),
      // blog
      createRoute('blog/kategori'),
      createRoute('blog/kategori/form', 'blog/kategori/Tambah'),
      createRoute('blog/subkategori', 'blog/sub_kategori'),
      createRoute('blog/subkategori/form', 'blog/sub_kategori/Tambah'),
      createRoute('blog/post'),
      createRoute('blog/post/form', 'blog/post/Tambah'),
      createRoute('blog/review'),
      createRoute('broadcast/wa'),
      createRoute('broadcast/template'),
      createRoute('broadcast/template/tambah', 'broadcast/buatTemplate'),
      createRoute('broadcast/wa/tambah', 'broadcast/buatBroadcast'),
      createRoute('broadcast/koneksi'),
      createRoute('broadcast'),
      createRoute('broadcast/form', 'broadcast/Tambah'),
      createRoute('images'),
    ],
    blaztap: [
      {
        path: '/',
        exact: true,
        component: () => <Redirect to="/blaztap/stock_product" />
      },
      createRoute('blaztap/bahan_baku'),
      createRoute('blaztap/bom'),
      createRoute('blaztap/bom/Tambah'),
      createRoute('blaztap/pembelian_bahan'),
      createRoute('blaztap/manufacture'),
      createRoute('blaztap/serial_number'),
      createRoute('blaztap/stock_product'),
      createRoute('blaztap/barang_keluar'),
      createRoute('blaztap/barang_dibawa'),
      createRoute('blaztap/order_blaztap'),
      createRoute('blaztap/laporan'),
      createRoute('blaztap/laporan_pendaftaran'),
      createRoute('blaztap_repair/return'),
      createRoute('blaztap_repair/product_return'),
      createRoute('blaztap_repair/manufacture_return'),
      createRoute('blaztap_repair/penguraian'),
      createRoute('blaztap_warranty/mesin'),
      createRoute('blaztap_warranty/diagnosa'),
      createRoute('blaztap_warranty/claim_policy'),
      createRoute('blaztap_warranty/claim_mitra'),
    ],
    sales_officer: [
      createRoute('outlet/analisa_outlet'),
      createRoute('outlet/update_pemilik'),
      createRoute('website/vidio'),
      createRoute('website/vidio/Tambah'),
      createRoute('website/vidio_kategori'),
      createRoute('website/vidio_kategori/Tambah'),
      createRoute('support/help_kategori'),
      createRoute('support/help_kategori/Tambah'),
      createRoute('blaztap/barang_keluar'),
      createRoute('blaztap/barang_dibawa'),
      createRoute('blaztap/order_blaztap'),
      createRoute('blaztap/laporan'),
      createRoute('blaztap/laporan_pendaftaran'),
      createRoute('blaztap_repair/return'),
      createRoute('blaztap_repair/product_return'),
      createRoute('blaztap_repair/manufacture_return'),
      createRoute('blaztap_repair/penguraian'),
      createRoute('blaztap_warranty/mesin'),
      createRoute('blaztap_warranty/diagnosa'),
      createRoute('blaztap_warranty/claim_policy'),
      createRoute('blaztap_warranty/claim_mitra'),
      createRoute('setting'),
      createRoute('outlet/extendtrial'),
      createRoute('voucher/approval'),
      createRoute('penjualan/produk/retail', 'penjualan/produk/index'),
      createRoute('penjualan/produk/retail/form', 'penjualan/produk/Tambah'),
      createRoute('penjualan/ringkasan/view'),
      createRoute('penjualan/ringkasan/view/topkota', 'penjualan/ringkasan/view/top_kota'),
      createRoute('penjualan/ringkasan/view/topsupplier', 'penjualan/ringkasan/view/top_supplier'),
      createRoute('penjualan/invoice'),
      createRoute('penjualan/data_order'),
      createRoute('penjualan/preorder'),
      createRoute('penjualan/preorder/[id]'),
      createRoute('penjualan/topproductview/view'),
      createRoute('penjualan/topproductview'),
      createRoute('penjualan/onchart/view'),
      createRoute('penjualan/onchart'),
      createRoute('penjualan/selesai/view'),
      createRoute('penjualan/selesai'),
      createRoute('penjualan/inproses/view'),
      createRoute('penjualan/inproses'),
      createRoute('penjualan/konfirmasiorder/view'),
      createRoute('penjualan/konfirmasiorder'),
      createRoute('penjualan/pendingorder/view'),
      createRoute('penjualan/pendingorder'),
      createRoute('penjualan/ongkir'),
      createRoute('penjualan/ongkir/view', 'penjualan/ongkir/Tambah'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      createRoute('dropbox'),
      createRoute('betatester/report'),
      createRoute('betatester/bug'),
      createRoute('betatester/data/view', 'betatester/data/form'),
      createRoute('betatester/pendaftaran/view', 'betatester/pendaftaran/form'),
      createRoute('betatester/data'),
      createRoute('betatester/pendaftaran'),
      createRoute('outlet/betatester', 'betatester'),
      createRoute('outlet/trialbisnis', 'outlettrialbisnis'),
      createRoute('outlet/owner', 'owner'),
      createRoute('outlet/owner/[id]/detail', 'owner/DetailOwner'),
      createRoute('referensiharga'),
      createRoute('feedback/bugtest', 'feedback/bug'),
      createRoute('voucher/data/order/tambah', 'order/daftar_order/addorder'),
      createRoute('profil'),
      createRoute('outlet/daftar-outlet', 'outlet'),
      createRoute('outlet/antrian-outlet', 'outlet/antrian_outlet'),

      createRoute('outlet/daftar-outlet/[id]/[tab]', 'outlet/Tambah'),
      createRoute('outlet/daftar-outlet/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('outlet/owner', 'owner'),
      createRoute('outlet/owner/[id]/detail', 'owner/DetailOwner'),
      createRoute('outlet/profil-outlet/[id]', 'outlet/detailOutlet'),
      createRoute('outlet/outlet-upgrade', 'outletupgrade'),
      createRoute('outlet/outlet-archive/[id]', 'outletarchive/detailarchive'),
      createRoute('outlet/outlet-archive', 'outletarchive'),
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/[id]/detail', 'outlet/detailOutlet'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/outlet-aktif', 'outlet/pertumbuhan_outlet'),
      createRoute('dashboard', 'dashboard/salesofficer'),
      createRoute('feedback/testimoni'),
      createRoute('feedback/bug/form', 'feedback/bugtestt/Tambah'),
      createRoute('feedback/bug/detail', 'feedback/bugtestt/Detail'),
      createRoute('feedback/bug/tambah', 'feedback/bugtestt/TambahDetail'),
      createRoute('feedback/bug'),
      createRoute('feedback/testimoni/form', 'feedback/testimoni/Tambah'),
      createRoute('feedback/masukkan'),
      createRoute('feedback/masukkan/form', 'feedback/masukkan/Tambah'),
      createRoute('support/faq'),
      createRoute('support/faq/form', 'support/faq/Tambah'),
      createRoute('support/help'),
      createRoute('support/help/form', 'support/help/Tambah'),
      createRoute('support/toc'),
      createRoute('support/privacy', 'support/pp'),
      {
        path: '/livechat',
        exact: true,
        component: () => <Redirect to="/livechat/none" />
      },
      createRoute('livechat/[room]', 'livechat'),
      createRoute('broadcast/wa'),
      createRoute('broadcast/template'),
      createRoute('broadcast/template/tambah', 'broadcast/buatTemplate'),
      createRoute('broadcast/wa/tambah', 'broadcast/buatBroadcast'),
      createRoute('broadcast/koneksi'),
      createRoute('broadcast'),
      createRoute('broadcast/form', 'broadcast/Tambah'),
      createRoute('autobroadcast'),
      createRoute('autobroadcast/form', 'autobroadcast/Tambah'),
      createRoute('prospek'),
      createRoute('prospek/sukses'),
      createRoute('prospek/batch'),
      createRoute('prospek/ringkasan'),
      createRoute('prospek_new'),
      createRoute('prospek_new/sukses'),
      createRoute('prospek_new/batch'),
      createRoute('prospek_new/ringkasan'),
      createRoute('prospek_new/klaim'),
      createRoute('jadwaltraining'),
      createRoute('jadwaltraining/trainingvirtual'),
      createRoute('jadwaltraining/trainingonlocation'),
      createRoute('jadwaltraining/ringkasan'),
      createRoute('event'),
      createRoute('event/[id]', 'event/Tambah'),
      createRoute('jadwaltraining/form', 'jadwaltraining/Tambah'),
      createRoute('jadwaltraining/selesai'),
      createRoute('jadwaltraining/dibatalkan'),
      createRoute('prospek_new/ringkasan/detail', 'prospek_new/ringkasan/Detail'),
      createRoute('daftar_order', 'order/daftar_order/index'),
      createRoute('daftar_order/[id]', 'order/daftar_order/Tambah'),
      // createRoute('laporan_order', 'order/laporan_order/index'),
      createRoute('ringkasan_order', 'order/ringkasan_order/index'),
      createRoute('ringkasan_order/detail', 'order/ringkasan_order/info'),
      // createRoute('ringkasan_order/[id]/info', 'promo/detail'),
      createRoute('repeat_order', 'order/repeat_order/index'),
      createRoute('xendit_status', 'order/xendit_status/index'),
    ],
    sales_manager: [
      createRoute('merchant/onboarding'),
      createRoute('merchant/income'),
      createRoute('merchant/modul'),
      createRoute('merchant/riwayat_qris'),
      createRoute('merchant/riwayat_qris/[id]', 'merchant/riwayat_qris/view'),
      createRoute('merchant/riwayat_qris/selfservice/[id]', 'merchant/riwayat_qris/selfservice'),
      createRoute('merchant/riwayat_qris/saldo/[id]', 'merchant/riwayat_qris/saldo'),
      createRoute('outlet/laporan'),
      createRoute('outlet/analisa_outlet'),
      createRoute('outlet/update_pemilik'),
      createRoute('klaim_prospek'),
      createRoute('website/vidio'),
      createRoute('website/vidio/Tambah'),
      createRoute('website/vidio_kategori'),
      createRoute('website/vidio_kategori/Tambah'),
      createRoute('blaztap/barang_keluar'),
      createRoute('blaztap/barang_dibawa'),
      createRoute('blaztap/order_blaztap'),
      createRoute('blaztap/serial_number'),
      createRoute('blaztap/stock_product'),
      createRoute('blaztap/laporan'),
      createRoute('blaztap/laporan_pendaftaran'),
      createRoute('blaztap_repair/return'),
      createRoute('blaztap_repair/product_return'),
      createRoute('blaztap_repair/manufacture_return'),
      createRoute('blaztap_repair/penguraian'),
      createRoute('blaztap_warranty/mesin'),
      createRoute('blaztap_warranty/diagnosa'),
      createRoute('blaztap_warranty/claim_policy'),
      createRoute('blaztap_warranty/claim_mitra'),
      createRoute('setting'),
      createRoute('outlet/extendtrial'),
      createRoute('promoter/daftar-promoter/[id]', 'promoter/view'),
      createRoute('promoter/daftar-promoter/[id]/[tab]', 'promoter/view'),
      createRoute('promoter/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('promoter/view'),
      createRoute('promoter'),

      createRoute('reseller/daftar-reseller/[id]', 'reseller/view'),
      createRoute('reseller/daftar-reseller/[id]/[tab]', 'reseller/view'),
      createRoute('reseller/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('reseller/view'),
      createRoute('reseller'),
      createRoute('voucher/approval'),
      createRoute('penjualan/produk/retail', 'penjualan/produk/index'),
      createRoute('penjualan/produk/retail/form', 'penjualan/produk/Tambah'),
      createRoute('penjualan/ringkasan/view'),
      createRoute('penjualan/ringkasan/view/topkota', 'penjualan/ringkasan/view/top_kota'),
      createRoute('penjualan/ringkasan/view/topsupplier', 'penjualan/ringkasan/view/top_supplier'),
      createRoute('penjualan/invoice'),
      createRoute('penjualan/data_order'),
      createRoute('penjualan/preorder'),
      createRoute('penjualan/preorder/[id]'),
      createRoute('penjualan/topproductview/view'),
      createRoute('penjualan/topproductview'),
      createRoute('penjualan/onchart/view'),
      createRoute('penjualan/onchart'),
      createRoute('penjualan/selesai/view'),
      createRoute('penjualan/selesai'),
      createRoute('penjualan/inproses/view'),
      createRoute('penjualan/inproses'),
      createRoute('penjualan/konfirmasiorder/view'),
      createRoute('penjualan/konfirmasiorder'),
      createRoute('penjualan/pendingorder/view'),
      createRoute('penjualan/pendingorder'),
      createRoute('penjualan/ongkir'),
      createRoute('penjualan/ongkir/view', 'penjualan/ongkir/Tambah'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      createRoute('dropbox'),
      createRoute('betatester/report'),
      createRoute('betatester/bug'),
      createRoute('betatester/data/view', 'betatester/data/form'),
      createRoute('betatester/pendaftaran/view', 'betatester/pendaftaran/form'),
      createRoute('betatester/data'),
      createRoute('betatester/pendaftaran'),
      createRoute('outlet/betatester', 'betatester'),
      createRoute('outlet/trialbisnis', 'outlettrialbisnis'),
      createRoute('outlet/owner', 'owner'),
      createRoute('outlet/owner/[id]/detail', 'owner/DetailOwner'),
      createRoute('referensiharga'),
      createRoute('feedback/bugtest', 'feedback/bug'),
      createRoute('voucher/data/order/tambah', 'order/daftar_order/addorder'),
      createRoute('profil'),
      createRoute('outlet/daftar-outlet', 'outlet'),
      createRoute('outlet/antrian-outlet', 'outlet/antrian_outlet'),

      createRoute('outlet/daftar-outlet/[id]/[tab]', 'outlet/Tambah'),
      createRoute('outlet/daftar-outlet/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('outlet/owner', 'owner'),
      createRoute('outlet/owner/[id]/detail', 'owner/DetailOwner'),
      createRoute('outlet/profil-outlet/[id]', 'outlet/detailOutlet'),
      createRoute('outlet/outlet-upgrade', 'outletupgrade'),
      createRoute('outlet/outlet-archive/[id]', 'outletarchive/detailarchive'),
      createRoute('outlet/outlet-archive', 'outletarchive'),
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/[id]/detail', 'outlet/detailOutlet'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/outlet-aktif', 'outlet/pertumbuhan_outlet'),
      createRoute('dashboard', 'dashboard/salesofficer'),
      createRoute('feedback/testimoni'),
      createRoute('feedback/bug/form', 'feedback/bugtestt/Tambah'),
      createRoute('feedback/bug/detail', 'feedback/bugtestt/Detail'),
      createRoute('feedback/bug/tambah', 'feedback/bugtestt/TambahDetail'),
      createRoute('feedback/bug'),
      createRoute('feedback/testimoni/form', 'feedback/testimoni/Tambah'),
      createRoute('feedback/masukkan'),
      createRoute('feedback/masukkan/form', 'feedback/masukkan/Tambah'),
      createRoute('support/help_kategori'),
      createRoute('support/help_kategori/Tambah'),
      createRoute('support/faq'),
      createRoute('support/faq/form', 'support/faq/Tambah'),
      createRoute('support/help'),
      createRoute('support/help/form', 'support/help/Tambah'),
      createRoute('support/toc'),
      createRoute('support/privacy', 'support/pp'),
      {
        path: '/livechat',
        exact: true,
        component: () => <Redirect to="/livechat/none" />
      },
      createRoute('livechat/[room]', 'livechat'),
      createRoute('broadcast/wa'),
      createRoute('broadcast/template'),
      createRoute('broadcast/template/tambah', 'broadcast/buatTemplate'),
      createRoute('broadcast/wa/tambah', 'broadcast/buatBroadcast'),
      createRoute('broadcast/koneksi'),
      createRoute('broadcast'),
      createRoute('broadcast/form', 'broadcast/Tambah'),
      createRoute('autobroadcast'),
      createRoute('autobroadcast/form', 'autobroadcast/Tambah'),
      createRoute('prospek'),
      createRoute('prospek/sukses'),
      createRoute('prospek/batch'),
      createRoute('prospek/ringkasan'),
      createRoute('prospek_new'),
      createRoute('prospek_new/sukses'),
      createRoute('prospek_new/batch'),
      createRoute('prospek_new/ringkasan'),
      createRoute('prospek_new/klaim'),
      createRoute('jadwaltraining'),
      createRoute('jadwaltraining/trainingvirtual'),
      createRoute('jadwaltraining/trainingonlocation'),
      createRoute('jadwaltraining/ringkasan'),
      createRoute('event'),
      createRoute('event/[id]', 'event/Tambah'),
      createRoute('jadwaltraining/form', 'jadwaltraining/Tambah'),
      createRoute('jadwaltraining/selesai'),
      createRoute('jadwaltraining/dibatalkan'),
      createRoute('prospek_new/ringkasan/detail', 'prospek_new/ringkasan/Detail'),
      createRoute('daftar_order', 'order/daftar_order/index'),
      createRoute('daftar_order/[id]', 'order/daftar_order/Tambah'),
      // createRoute('laporan_order', 'order/laporan_order/index'),
      createRoute('ringkasan_order', 'order/ringkasan_order/index'),
      createRoute('ringkasan_order/detail', 'order/ringkasan_order/info'),
      // createRoute('ringkasan_order/[id]/info', 'promo/detail'),
      createRoute('repeat_order', 'order/repeat_order/index'),
      createRoute('xendit_status', 'order/xendit_status/index'),
    ],
    cs: [
      createRoute('merchant/onboarding'),
      createRoute('merchant/income'),
      createRoute('merchant/modul'),
      createRoute('merchant/riwayat_qris'),
      createRoute('merchant/riwayat_qris/[id]', 'merchant/riwayat_qris/view'),
      createRoute('merchant/riwayat_qris/selfservice/[id]', 'merchant/riwayat_qris/selfservice'),
      createRoute('merchant/riwayat_qris/saldo/[id]', 'merchant/riwayat_qris/saldo'),
      createRoute('outlet/laporan'),
      createRoute('outlet/analisa_outlet'),
      createRoute('outlet/update_pemilik'),
      createRoute('website/vidio'),
      createRoute('website/vidio/Tambah'),
      createRoute('website/vidio_kategori'),
      createRoute('website/vidio_kategori/Tambah'),
      createRoute('support/help_kategori'),
      createRoute('support/help_kategori/Tambah'),
      createRoute('blaztap/barang_keluar'),
      createRoute('blaztap/barang_dibawa'),
      createRoute('blaztap/order_blaztap'),
      createRoute('blaztap/laporan'),
      createRoute('blaztap/laporan_pendaftaran'),
      createRoute('blaztap_repair/return'),
      createRoute('blaztap_repair/product_return'),
      createRoute('blaztap_repair/manufacture_return'),
      createRoute('blaztap_repair/penguraian'),
      createRoute('blaztap_warranty/mesin'),
      createRoute('blaztap_warranty/diagnosa'),
      createRoute('blaztap_warranty/claim_policy'),
      createRoute('blaztap_warranty/claim_mitra'),
      // blog
      createRoute('blog/kategori'),
      createRoute('blog/kategori/form', 'blog/kategori/Tambah'),
      createRoute('blog/subkategori', 'blog/sub_kategori'),
      createRoute('blog/subkategori/form', 'blog/sub_kategori/Tambah'),
      createRoute('blog/post'),
      createRoute('blog/post/form', 'blog/post/Tambah'),
      createRoute('blog/review'),
      createRoute('voucher/approval'),
      createRoute('penjualan/produk/retail', 'penjualan/produk/index'),
      createRoute('penjualan/produk/retail/form', 'penjualan/produk/Tambah'),
      createRoute('penjualan/ringkasan/view'),
      createRoute('penjualan/ringkasan/view/topkota', 'penjualan/ringkasan/view/top_kota'),
      createRoute('penjualan/ringkasan/view/topsupplier', 'penjualan/ringkasan/view/top_supplier'),
      createRoute('penjualan/invoice'),
      createRoute('penjualan/data_order'),
      createRoute('penjualan/preorder'),
      createRoute('penjualan/preorder/[id]'),
      createRoute('penjualan/topproductview/view'),
      createRoute('penjualan/topproductview'),
      createRoute('penjualan/onchart/view'),
      createRoute('penjualan/onchart'),
      createRoute('penjualan/selesai/view'),
      createRoute('penjualan/selesai'),
      createRoute('penjualan/inproses/view'),
      createRoute('penjualan/inproses'),
      createRoute('penjualan/konfirmasiorder/view'),
      createRoute('penjualan/konfirmasiorder'),
      createRoute('penjualan/pendingorder/view'),
      createRoute('penjualan/pendingorder'),
      createRoute('penjualan/ongkir'),
      createRoute('penjualan/ongkir/view', 'penjualan/ongkir/Tambah'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      createRoute('dropbox'),
      createRoute('outletaktivasi'),
      createRoute('outletaktivasi/view', 'outletaktivasi/aplikasicustom/view'),
      createRoute('outletaktivasi/view'),
      createRoute('outletaktivasi/custom', 'outletaktivasi/aplikasicustom/index'),
      createRoute('outletaktivasi/draf'),
      createRoute('betatester/report'),
      createRoute('betatester/bug'),
      createRoute('betatester/data/view', 'betatester/data/form'),
      createRoute('betatester/pendaftaran/view', 'betatester/pendaftaran/form'),
      createRoute('betatester/data'),
      createRoute('betatester/pendaftaran'),
      createRoute('outlet/betatester', 'betatester'),
      createRoute('outlet/trialbisnis', 'outlettrialbisnis'),
      createRoute('referensiharga'),
      createRoute('feedback/bugtest', 'feedback/bug'),
      createRoute('voucher/data/order/tambah', 'order/daftar_order/addorder'),
      createRoute('profil'),
      createRoute('outlet/daftar-outlet', 'outlet'),
      createRoute('outlet/antrian-outlet', 'outlet/antrian_outlet'),

      createRoute('outlet/daftar-outlet/[id]/[tab]', 'outlet/Tambah'),
      createRoute('outlet/daftar-outlet/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('outlet/owner', 'owner'),
      createRoute('outlet/owner/[id]/detail', 'owner/DetailOwner'),
      createRoute('outlet/profil-outlet/[id]', 'outlet/detailOutlet'),
      createRoute('outlet/outlet-upgrade', 'outletupgrade'),
      createRoute('outlet/outlet-archive/[id]', 'outletarchive/detailarchive'),
      createRoute('outlet/outlet-archive', 'outletarchive'),
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/[id]/detail', 'outlet/detailOutlet'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/outlet-aktif', 'outlet/pertumbuhan_outlet'),
      createRoute('dashboard', 'dashboard/cs'),
      createRoute('feedback/testimoni'),
      createRoute('feedback/bug/form', 'feedback/bugtestt/Tambah'),
      createRoute('feedback/bug/detail', 'feedback/bugtestt/Detail'),
      createRoute('feedback/bug/tambah', 'feedback/bugtestt/TambahDetail'),
      createRoute('feedback/bug'),
      createRoute('feedback/testimoni/form', 'feedback/testimoni/Tambah'),
      createRoute('feedback/masukkan'),
      createRoute('feedback/masukkan/form', 'feedback/masukkan/Tambah'),
      createRoute('support/faq'),
      createRoute('support/faq/form', 'support/faq/Tambah'),
      createRoute('support/help'),
      createRoute('support/help/form', 'support/help/Tambah'),
      createRoute('support/toc'),
      createRoute('support/privacy', 'support/pp'),
      {
        path: '/livechat',
        exact: true,
        component: () => <Redirect to="/livechat/none" />
      },
      createRoute('livechat/[room]', 'livechat'),
      createRoute('broadcast/wa'),
      createRoute('broadcast/template'),
      createRoute('broadcast/template/tambah', 'broadcast/buatTemplate'),
      createRoute('broadcast/wa/tambah', 'broadcast/buatBroadcast'),
      createRoute('broadcast/koneksi'),
      createRoute('broadcast'),
      createRoute('broadcast/form', 'broadcast/Tambah'),
      createRoute('autobroadcast'),
      createRoute('autobroadcast/form', 'autobroadcast/Tambah'),
      createRoute('prospek'),
      createRoute('prospek/sukses'),
      createRoute('prospek/batch'),
      createRoute('prospek/ringkasan'),
      createRoute('prospek_new'),
      createRoute('prospek_new/sukses'),
      createRoute('prospek_new/batch'),
      createRoute('prospek_new/ringkasan'),
      createRoute('prospek_new/klaim'),
      createRoute('jadwaltraining'),
      createRoute('jadwaltraining/trainingvirtual'),
      createRoute('jadwaltraining/trainingonlocation'),
      createRoute('jadwaltraining/ringkasan'),
      createRoute('event'),
      createRoute('event/[id]', 'event/Tambah'),
      createRoute('jadwaltraining/form', 'jadwaltraining/Tambah'),
      createRoute('jadwaltraining/selesai'),
      createRoute('jadwaltraining/dibatalkan'),
      createRoute('prospek_new/ringkasan/detail', 'prospek_new/ringkasan/Detail'),
      createRoute('daftar_order', 'order/daftar_order/index'),
      createRoute('daftar_order/[id]', 'order/daftar_order/Tambah'),
      // createRoute('laporan_order', 'order/laporan_order/index'),
      createRoute('ringkasan_order', 'order/ringkasan_order/index'),
      createRoute('ringkasan_order/detail', 'order/ringkasan_order/info'),
      // createRoute('ringkasan_order/[id]/info', 'promo/detail'),
      createRoute('repeat_order', 'order/repeat_order/index'),
      createRoute('xendit_status', 'order/xendit_status/index'),

      createRoute('setting'),
    ],
    admin: [
      createRoute('merchant/onboarding'),
      createRoute('merchant/income'),
      createRoute('merchant/modul'),
      createRoute('merchant/riwayat_qris'),
      createRoute('merchant/riwayat_qris/[id]', 'merchant/riwayat_qris/view'),
      createRoute('merchant/riwayat_qris/selfservice/[id]', 'merchant/riwayat_qris/selfservice'),
      createRoute('merchant/riwayat_qris/saldo/[id]', 'merchant/riwayat_qris/saldo'),
      createRoute('sales_v2'),
      createRoute('sales_v2/Tambah'),
      createRoute('sales_v2/nonaktif'),
      createRoute('sales_v2/riwayat'),
      createRoute('sales_v2/performa'),
      createRoute('klaim_prospek'),
      createRoute('outlet/analisa_outlet'),
      createRoute('outlet/update_pemilik'),
      createRoute('prospek_new/all_prospek'),
      createRoute('blog/analisis'),
      createRoute('website/vidio'),
      createRoute('website/vidio/Tambah'),
      createRoute('website/vidio_kategori'),
      createRoute('website/vidio_kategori/Tambah'),
      createRoute('support/help_kategori'),
      createRoute('support/help_kategori/Tambah'),
      createRoute('outletaktivasi/view'),
      createRoute('sales_v2/detailsales/[id]', 'sales_v2/detailsales'),
      createRoute('sales_v2/detailsales/[id]/[tab]', 'sales_v2/detailsales'),
      createRoute('survey/jawaban'),
      createRoute('survey/report'),
      createRoute('survey/analisa'),
      createRoute('survey/view', 'survey/Tambah'),
      createRoute('survey'),
      createRoute('outlet/wa_bisnis'),
      createRoute('outlet/extendtrial'),
      createRoute('blaztap/bahan_baku'),
      createRoute('blaztap/bom'),
      createRoute('blaztap/bom/Tambah'),
      createRoute('blaztap/pembelian_bahan'),
      createRoute('blaztap/manufacture'),
      createRoute('blaztap/serial_number'),
      createRoute('blaztap/stock_product'),
      createRoute('blaztap/barang_keluar'),
      createRoute('blaztap/barang_dibawa'),
      createRoute('blaztap/order_blaztap'),
      createRoute('blaztap/laporan'),
      createRoute('blaztap/laporan_pendaftaran'),
      createRoute('blaztap_repair/return'),
      createRoute('blaztap_repair/product_return'),
      createRoute('blaztap_repair/manufacture_return'),
      createRoute('blaztap_repair/penguraian'),
      createRoute('blaztap_warranty/mesin'),
      createRoute('blaztap_warranty/diagnosa'),
      createRoute('blaztap_warranty/claim_policy'),
      createRoute('blaztap_warranty/claim_mitra'),
      createRoute('betatester/report'),
      createRoute('betatester/bug'),
      createRoute('betatester/data/view', 'betatester/data/form'),
      createRoute('betatester/pendaftaran/view', 'betatester/pendaftaran/form'),
      createRoute('betatester/data'),
      createRoute('betatester/pendaftaran'),
      createRoute('dropbox/getaccesscode', 'dropbox/getaccescode'),
      createRoute('dropbox'),
      createRoute('outlet/betatester', 'betatester'),
      createRoute('outlet/trialbisnis', 'outlettrialbisnis'),
      createRoute('referensiharga'),
      createRoute('voucher/data/rsl', 'voucher/datarsl'),
      createRoute('voucher/approval'),
      createRoute('voucher/laporan/pendapatan', 'voucher/laporanpendapatan'),
      createRoute('penjualan/produk/retail', 'penjualan/produk/index'),
      createRoute('penjualan/produk/retail/form', 'penjualan/produk/Tambah'),
      createRoute('outletaktivasi/custom/view', 'outletaktivasi/aplikasicustom/view'),
      createRoute('outletaktivasi/custom', 'outletaktivasi/aplikasicustom/index'),
      createRoute('outletaktivasi/upgrade', 'outletaktivasi/upgrade/index'),
      createRoute('outletaktivasi/ringkasan', 'outletaktivasi/ringkasan/index'),
      createRoute('outletaktivasi/laporan', 'outletaktivasi/laporan/index'),
      createRoute('penjualan/ringkasan/view'),
      createRoute('penjualan/ringkasan/view/topkota', 'penjualan/ringkasan/view/top_kota'),
      createRoute('penjualan/ringkasan/view/topsupplier', 'penjualan/ringkasan/view/top_supplier'),
      createRoute('penjualan/ringkasan'),
      createRoute('penjualan/invoice'),
      createRoute('penjualan/data_order'),
      createRoute('penjualan/preorder'),
      createRoute('penjualan/preorder/[id]'),
      createRoute('penjualan/topproductview/view'),
      createRoute('penjualan/topproductview'),
      createRoute('penjualan/onchart/view'),
      createRoute('penjualan/onchart'),
      createRoute('penjualan/selesai/view'),
      createRoute('penjualan/selesai'),
      createRoute('penjualan/inproses/view'),
      createRoute('penjualan/inproses'),
      createRoute('penjualan/konfirmasiorder/view'),
      createRoute('penjualan/konfirmasiorder'),
      createRoute('penjualan/pendingorder/view'),
      createRoute('penjualan/pendingorder'),
      createRoute('penjualan/ongkir'),
      createRoute('penjualan/ongkir/view', 'penjualan/ongkir/Tambah'),
      createRoute('isiweb/form', 'website/isiwebsite/form'),
      createRoute('isiweb', 'website/isiwebsite/index'),
      createRoute('spesifikasilangganan/form', 'website/spesifikasilangganan/form'),
      createRoute('spesifikasilangganan', 'website/spesifikasilangganan/index'),
      createRoute('seo'),
      createRoute('outlet/laporan', 'outlet/laporan/index'),
      createRoute('outlet/bonus', 'outlet/bonus/index'),
      createRoute('outletaktivasi/publish'),
      createRoute('outletaktivasi/pembayaran'),
      createRoute('outletaktivasi/draf'),
      createRoute('sales/job/verif/riwayat', 'job/admin/verif/riwayat'),
      createRoute('sales/job', 'job/admin/index'),
      createRoute('dashboard'),
      createRoute('ringkasan'),
      createRoute('profil'),
      createRoute('referal/pengaturan'),
      createRoute('referal/pengaturan/form'),
      createRoute('referal/data'),
      createRoute('referal/data/detail'),
      createRoute('referal/pemakaian'),
      createRoute('poin'),
      createRoute('poin/pengaturan'),
      createRoute('poin/riwayat'),
      createRoute('poin/outlet'),
      createRoute('poin/outlet/[id]'),
      createRoute('promo'),
      createRoute('promo/detail'),
      createRoute('promo/data'),
      createRoute('promo/data/form'),
      createRoute('qris/aktivasi'),
      createRoute('setting'),
      createRoute('confiq'),
      createRoute('confiq/form'),
      createRoute('prospek'),
      createRoute('prospek/sukses'),
      createRoute('prospek/performa'),
      createRoute('prospek/batch'),
      createRoute('prospek_new'),
      createRoute('prospek_new/sukses'),
      createRoute('prospek_new/performa_cs'),
      createRoute('prospek_new/performa_sales'),
      createRoute('prospek_new/batch'),
      createRoute('jadwaltraining'),
      createRoute('jadwaltraining/trainingvirtual'),
      createRoute('jadwaltraining/trainingonlocation'),
      createRoute('jadwaltraining/ringkasan'),
      createRoute('prospek/ringkasan'),
      createRoute('prospek_new/ringkasan'),
      createRoute('prospek_new/klaim'),
      createRoute('withdrawal'),
      createRoute('withdrawal/proses'),
      createRoute('withdrawal/sukses'),
      createRoute('withdrawal/batal'),
      createRoute('jadwaltraining/form', 'jadwaltraining/Tambah'),
      createRoute('jadwaltraining/selesai'),
      createRoute('jadwaltraining/dibatalkan'),
      createRoute('prospek_new/ringkasan/detail', 'prospek_new/ringkasan/Detail'),
      createRoute('partner/form', 'partner/Tambah'),
      createRoute('partner', 'partner/index'),
      createRoute('partner/view'),
      createRoute('partner/tambah', 'partner/Tambah'),
      createRoute('partner/saldo'),
      createRoute('partner/saldo/riwayat', 'partner/riwayat'),
      createRoute('partner/saldo/view'),

      createRoute('partner/saldo/benefit', 'sales/bonus'),
      createRoute('voucher/detail', 'voucher/ringkasan/detail'),
      createRoute('voucher/ringkasan'),
      createRoute('produk/review'),
      createRoute('sales/saldo'),
      createRoute('sales/datareferal'),
      createRoute('sales/progress/detail'),
      createRoute('sales/kunjungan/form', 'sales/kunjungan/Tambah'),
      createRoute('sales/progress'),
      createRoute('sales/reject', 'sales/ditolak'),
      createRoute('sales/suspend'),
      createRoute('sales/pendaftaran'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      createRoute('feedback/testimoni'),
      createRoute('feedback/bug/form', 'feedback/bugtestt/Tambah'),
      createRoute('feedback/bug/detail', 'feedback/bugtestt/Detail'),
      createRoute('feedback/bug/tambah', 'feedback/bugtestt/TambahDetail'),
      createRoute('feedback/bug', 'feedback/bugtestt'),
      createRoute('sales'),
      createRoute('sales/view'),
      createRoute('sales/form', 'sales/Tambah'),
      createRoute('user'),
      createRoute('user/form', 'user/Tambah'),
      createRoute('produk/kategori'),
      createRoute('blog/kategori'),
      createRoute('produk/kategori/form', 'produk/kategori/Tambah'),
      createRoute('blog/kategori/form', 'blog/kategori/Tambah'),
      createRoute('blog/subkategori', 'blog/sub_kategori'),
      createRoute('blog/subkategori/form', 'blog/sub_kategori/Tambah'),
      createRoute('blog/post'),
      createRoute('blog/post/form', 'blog/post/Tambah'),
      createRoute('blog/review'),
      createRoute('produk/varian'),
      createRoute('produk/varian/form', 'produk/varian/Tambah'),
      createRoute('produk/sku'),
      createRoute('produk/sku/form', 'produk/sku/Tambah'),
      createRoute('feedback/testimoni/form', 'feedback/testimoni/Tambah'),
      createRoute('feedback/masukkan'),
      createRoute('feedback/masukkan/form', 'feedback/masukkan/Tambah'),
      createRoute('support/faq'),
      createRoute('support/faq/form', 'support/faq/Tambah'),
      createRoute('support/help'),
      createRoute('support/help/form', 'support/help/Tambah'),
      createRoute('support/toc'),
      createRoute('support/privacy', 'support/pp'),
      createRoute('support/snkref'),
      createRoute('support/snkcustom'),
      createRoute('support/snkrefoutlet'),
      {
        path: '/livechat',
        exact: true,
        component: () => <Redirect to="/livechat/none" />
      },
      createRoute('livechat/[room]', 'livechat'),
      createRoute('daftar_order', 'order/daftar_order/index'),
      createRoute('daftar_order/[id]', 'order/daftar_order/Tambah'),
      createRoute('laporan_order', 'order/laporan_order/index'),
      createRoute('ringkasan_order', 'order/ringkasan_order/index'),
      createRoute('ringkasan_order/detail', 'order/ringkasan_order/info'),
      createRoute('ringkasan_order/[id]/info', 'promo/detail'),
      createRoute('repeat_order', 'order/repeat_order/index'),
      createRoute('xendit_status', 'order/xendit_status/index'),
      createRoute('repeat_order/[id]/detail', 'order/repeat_order/info'),
      createRoute('outlet/daftar-outlet', 'outlet'),

      createRoute('outlet/daftar-outlet/[id]/[tab]', 'outlet/Tambah'),
      createRoute('outlet/daftar-outlet/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('outlet/owner', 'owner'),
      createRoute('outlet/owner/[id]/detail', 'owner/DetailOwner'),
      createRoute('outlet/profil-outlet/[id]', 'outlet/detailOutlet'),
      createRoute('outlet/outlet-upgrade', 'outletupgrade'),
      createRoute('outlet/outlet-archive/[id]', 'outletarchive/detailarchive'),
      createRoute('outlet/outlet-archive', 'outletarchive'),
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/[id]/detail', 'outlet/detailOutlet'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/outlet-aktif', 'outlet/pertumbuhan_outlet'),
      createRoute('broadcast/wa'),
      createRoute('broadcast/template'),
      createRoute('broadcast/template/tambah', 'broadcast/buatTemplate'),
      createRoute('broadcast/wa/tambah', 'broadcast/buatBroadcast'),
      createRoute('broadcast/koneksi'),
      createRoute('broadcast'),
      createRoute('broadcast/form', 'broadcast/Tambah'),
      createRoute('autobroadcast'),
      createRoute('autobroadcast/form', 'autobroadcast/Tambah'),
      createRoute('images'),
      createRoute('voucher/pembuatan'),
      createRoute('voucher/request'),
      createRoute('voucher/pembuatan/form', 'voucher/pembuatan/Tambah'),
      createRoute('voucher/pembuatan/detail', 'voucher/pembuatan/Detail'),
      createRoute('voucher/data'),
      createRoute('voucher/pemakaian'),
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ],
    finance: [
      createRoute('merchant/onboarding'),
      createRoute('merchant/income'),
      createRoute('merchant/modul'),
      createRoute('merchant/riwayat_qris'),
      createRoute('merchant/riwayat_qris/[id]', 'merchant/riwayat_qris/view'),
      createRoute('merchant/riwayat_qris/selfservice/[id]', 'merchant/riwayat_qris/selfservice'),
      createRoute('merchant/riwayat_qris/saldo/[id]', 'merchant/riwayat_qris/saldo'),
      createRoute('promoter/daftar-promoter/[id]', 'promoter/view'),
      createRoute('promoter/daftar-promoter/[id]/[tab]', 'promoter/view'),
      createRoute('promoter/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('promoter/view'),
      createRoute('promoter'),
      createRoute('reseller/daftar-reseller/[id]', 'reseller/view'),
      createRoute('reseller/daftar-reseller/[id]/[tab]', 'reseller/view'),
      createRoute('reseller/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('reseller/view'),
      createRoute('reseller'),
      createRoute('outlet/analisa_outlet'),
      createRoute('outlet/update_pemilik'),
      createRoute('prospek_new/all_prospek'),
      createRoute('blog/analisis'),
      createRoute('support/help_kategori'),
      createRoute('support/help_kategori/Tambah'),
      createRoute('survey/jawaban'),
      createRoute('survey/report'),
      createRoute('survey/analisa'),
      createRoute('survey/view', 'survey/Tambah'),
      createRoute('survey'),
      createRoute('outlet/wa_bisnis'),
      createRoute('outlet/extendtrial'),
      createRoute('blaztap/bahan_baku'),
      createRoute('blaztap/bom'),
      createRoute('blaztap/bom/Tambah'),
      createRoute('blaztap/pembelian_bahan'),
      createRoute('blaztap/manufacture'),
      createRoute('blaztap/serial_number'),
      createRoute('blaztap/stock_product'),
      createRoute('blaztap/barang_keluar'),
      createRoute('blaztap/barang_dibawa'),
      createRoute('blaztap/order_blaztap'),
      createRoute('blaztap/laporan'),
      createRoute('blaztap/laporan_pendaftaran'),
      createRoute('blaztap_repair/return'),
      createRoute('blaztap_repair/product_return'),
      createRoute('blaztap_repair/manufacture_return'),
      createRoute('blaztap_repair/penguraian'),
      createRoute('blaztap_warranty/mesin'),
      createRoute('blaztap_warranty/diagnosa'),
      createRoute('blaztap_warranty/claim_policy'),
      createRoute('blaztap_warranty/claim_mitra'),
      createRoute('betatester/report'),
      createRoute('betatester/bug'),
      createRoute('betatester/data/view', 'betatester/data/form'),
      createRoute('betatester/pendaftaran/view', 'betatester/pendaftaran/form'),
      createRoute('betatester/data'),
      createRoute('betatester/pendaftaran'),
      createRoute('outlet/betatester', 'betatester'),
      createRoute('outlet/trialbisnis', 'outlettrialbisnis'),
      createRoute('referensiharga'),
      createRoute('voucher/data/rsl', 'voucher/datarsl'),
      createRoute('voucher/approval'),
      createRoute('voucher/laporan/pendapatan', 'voucher/laporanpendapatan'),
      createRoute('penjualan/produk/retail', 'penjualan/produk/index'),
      createRoute('penjualan/produk/retail/form', 'penjualan/produk/Tambah'),
      createRoute('outletaktivasi/custom/view', 'outletaktivasi/aplikasicustom/view'),
      createRoute('outletaktivasi/custom', 'outletaktivasi/aplikasicustom/index'),
      createRoute('outletaktivasi/upgrade', 'outletaktivasi/upgrade/index'),
      createRoute('outletaktivasi/ringkasan', 'outletaktivasi/ringkasan/index'),
      createRoute('outletaktivasi/laporan', 'outletaktivasi/laporan/index'),
      createRoute('penjualan/ringkasan/view'),
      createRoute('penjualan/ringkasan/view/topkota', 'penjualan/ringkasan/view/top_kota'),
      createRoute('penjualan/ringkasan/view/topsupplier', 'penjualan/ringkasan/view/top_supplier'),
      createRoute('penjualan/ringkasan'),
      createRoute('penjualan/invoice'),
      createRoute('penjualan/data_order'),
      createRoute('penjualan/preorder'),
      createRoute('penjualan/preorder/[id]'),
      createRoute('penjualan/topproductview/view'),
      createRoute('penjualan/topproductview'),
      createRoute('penjualan/onchart/view'),
      createRoute('penjualan/onchart'),
      createRoute('penjualan/selesai/view'),
      createRoute('penjualan/selesai'),
      createRoute('penjualan/inproses/view'),
      createRoute('penjualan/inproses'),
      createRoute('penjualan/konfirmasiorder/view'),
      createRoute('penjualan/konfirmasiorder'),
      createRoute('penjualan/pendingorder/view'),
      createRoute('penjualan/pendingorder'),
      createRoute('penjualan/ongkir'),
      createRoute('penjualan/ongkir/view', 'penjualan/ongkir/Tambah'),
      createRoute('isiweb/form', 'website/isiwebsite/form'),
      createRoute('isiweb', 'website/isiwebsite/index'),
      createRoute('spesifikasilangganan/form', 'website/spesifikasilangganan/form'),
      createRoute('spesifikasilangganan', 'website/spesifikasilangganan/index'),
      createRoute('seo'),
      createRoute('outlet/laporan', 'outlet/laporan/index'),
      createRoute('outlet/bonus', 'outlet/bonus/index'),
      createRoute('outletaktivasi/publish'),
      createRoute('outletaktivasi/pembayaran'),
      createRoute('outletaktivasi/draf'),
      createRoute('sales/job/verif/riwayat', 'job/admin/verif/riwayat'),
      createRoute('sales/job', 'job/admin/index'),
      createRoute('dashboard'),
      createRoute('ringkasan'),
      createRoute('profil'),
      createRoute('referal/pengaturan'),
      createRoute('referal/pengaturan/form'),
      createRoute('referal/data'),
      createRoute('referal/data/detail'),
      createRoute('referal/pemakaian'),
      createRoute('poin'),
      createRoute('poin/pengaturan'),
      createRoute('poin/riwayat'),
      createRoute('poin/outlet'),
      createRoute('poin/outlet/[id]'),
      createRoute('promo'),
      createRoute('promo/detail'),
      createRoute('promo/data'),
      createRoute('promo/data/form'),
      createRoute('qris/aktivasi'),
      createRoute('setting'),
      createRoute('confiq'),
      createRoute('confiq/form'),
      createRoute('prospek'),
      createRoute('prospek/sukses'),
      createRoute('prospek/performa'),
      createRoute('prospek/batch'),
      createRoute('prospek_new'),
      createRoute('prospek_new/sukses'),
      createRoute('prospek_new/performa_cs'),
      createRoute('prospek_new/performa_sales'),
      createRoute('prospek_new/batch'),
      createRoute('jadwaltraining'),
      createRoute('jadwaltraining/trainingvirtual'),
      createRoute('jadwaltraining/trainingonlocation'),
      createRoute('jadwaltraining/ringkasan'),
      createRoute('prospek/ringkasan'),
      createRoute('prospek_new/ringkasan'),
      createRoute('prospek_new/klaim'),
      createRoute('withdrawal'),
      createRoute('withdrawal/proses'),
      createRoute('withdrawal/sukses'),
      createRoute('withdrawal/batal'),
      createRoute('jadwaltraining/form', 'jadwaltraining/Tambah'),
      createRoute('jadwaltraining/selesai'),
      createRoute('jadwaltraining/dibatalkan'),
      createRoute('prospek_new/ringkasan/detail', 'prospek_new/ringkasan/Detail'),
      createRoute('partner/form', 'partner/Tambah'),
      createRoute('partner', 'partner/index'),
      createRoute('partner/saldo'),
      createRoute('partner/saldo/riwayat', 'partner/riwayat'),
      createRoute('partner/saldo/view'),

      createRoute('partner/saldo/benefit', 'sales/bonus'),
      createRoute('voucher/detail', 'voucher/ringkasan/detail'),
      createRoute('voucher/ringkasan'),
      createRoute('produk/review'),
      createRoute('sales/saldo'),
      createRoute('sales/datareferal'),
      createRoute('sales/progress/detail'),
      createRoute('sales/kunjungan/form', 'sales/kunjungan/Tambah'),
      createRoute('sales/progress'),
      createRoute('sales/reject', 'sales/ditolak'),
      createRoute('sales/suspend'),
      createRoute('sales/pendaftaran'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      createRoute('feedback/testimoni'),
      createRoute('feedback/bug/form', 'feedback/bugtestt/Tambah'),
      createRoute('feedback/bug/detail', 'feedback/bugtestt/Detail'),
      createRoute('feedback/bug/tambah', 'feedback/bugtestt/TambahDetail'),
      createRoute('feedback/bug', 'feedback/bugtestt'),
      createRoute('sales'),
      createRoute('sales/view'),
      createRoute('sales/form', 'sales/Tambah'),
      createRoute('user'),
      createRoute('user/form', 'user/Tambah'),
      createRoute('produk/kategori'),
      createRoute('blog/kategori'),
      createRoute('produk/kategori/form', 'produk/kategori/Tambah'),
      createRoute('blog/kategori/form', 'blog/kategori/Tambah'),
      createRoute('blog/subkategori', 'blog/sub_kategori'),
      createRoute('blog/subkategori/form', 'blog/sub_kategori/Tambah'),
      createRoute('blog/post'),
      createRoute('blog/post/form', 'blog/post/Tambah'),
      createRoute('blog/review'),
      createRoute('produk/varian'),
      createRoute('produk/varian/form', 'produk/varian/Tambah'),
      createRoute('produk/sku'),
      createRoute('produk/sku/form', 'produk/sku/Tambah'),
      createRoute('feedback/testimoni/form', 'feedback/testimoni/Tambah'),
      createRoute('feedback/masukkan'),
      createRoute('feedback/masukkan/form', 'feedback/masukkan/Tambah'),
      createRoute('support/faq'),
      createRoute('support/faq/form', 'support/faq/Tambah'),
      createRoute('support/help'),
      createRoute('support/help/form', 'support/help/Tambah'),
      createRoute('support/toc'),
      createRoute('support/privacy', 'support/pp'),
      createRoute('support/snkref'),
      createRoute('support/snkcustom'),
      createRoute('support/snkrefoutlet'),
      {
        path: '/livechat',
        exact: true,
        component: () => <Redirect to="/livechat/none" />
      },
      createRoute('livechat/[room]', 'livechat'),
      createRoute('daftar_order', 'order/daftar_order/index'),
      createRoute('daftar_order/[id]', 'order/daftar_order/Tambah'),
      createRoute('laporan_order', 'order/laporan_order/index'),
      createRoute('ringkasan_order', 'order/ringkasan_order/index'),
      createRoute('ringkasan_order/detail', 'order/ringkasan_order/info'),
      createRoute('ringkasan_order/[id]/info', 'promo/detail'),
      createRoute('repeat_order', 'order/repeat_order/index'),
      createRoute('xendit_status', 'order/xendit_status/index'),
      createRoute('repeat_order/[id]/detail', 'order/repeat_order/info'),
      createRoute('outlet/daftar-outlet', 'outlet'),

      createRoute('outlet/daftar-outlet/[id]/[tab]', 'outlet/Tambah'),
      createRoute('outlet/daftar-outlet/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('outlet/owner', 'owner'),
      createRoute('outlet/owner/[id]/detail', 'owner/DetailOwner'),
      createRoute('outlet/profil-outlet/[id]', 'outlet/detailOutlet'),
      createRoute('outlet/outlet-upgrade', 'outletupgrade'),
      createRoute('outlet/outlet-archive/[id]', 'outletarchive/detailarchive'),
      createRoute('outlet/outlet-archive', 'outletarchive'),
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/[id]/detail', 'outlet/detailOutlet'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/outlet-aktif', 'outlet/pertumbuhan_outlet'),
      createRoute('broadcast/wa'),
      createRoute('broadcast/template'),
      createRoute('broadcast/template/tambah', 'broadcast/buatTemplate'),
      createRoute('broadcast/wa/tambah', 'broadcast/buatBroadcast'),
      createRoute('broadcast/koneksi'),
      createRoute('broadcast'),
      createRoute('broadcast/form', 'broadcast/Tambah'),
      createRoute('autobroadcast'),
      createRoute('autobroadcast/form', 'autobroadcast/Tambah'),
      createRoute('images'),
      createRoute('voucher/pembuatan'),
      createRoute('voucher/request'),
      createRoute('voucher/pembuatan/form', 'voucher/pembuatan/Tambah'),
      createRoute('voucher/pembuatan/detail', 'voucher/pembuatan/Detail'),
      createRoute('voucher/data'),
      createRoute('voucher/pemakaian'),
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ],
    routes: [
      createRoute('merchant/onboarding'),
      createRoute('merchant/income'),
      createRoute('merchant/modul'),
      createRoute('merchant/riwayat_qris'),
      createRoute('merchant/riwayat_qris/[id]', 'merchant/riwayat_qris/view'),
      createRoute('merchant/riwayat_qris/selfservice/[id]', 'merchant/riwayat_qris/selfservice'),
      createRoute('merchant/riwayat_qris/saldo/[id]', 'merchant/riwayat_qris/saldo'),
      createRoute('klaim_prospek'),
      createRoute('outlet/analisa_outlet'),
      createRoute('outlet/update_pemilik'),
      createRoute('prospek_new/all_prospek'),
      createRoute('blog/analisis'),
      createRoute('support/help_kategori'),
      createRoute('support/help_kategori/Tambah'),
      createRoute('website/vidio'),
      createRoute('website/vidio/Tambah'),
      createRoute('website/vidio_kategori'),
      createRoute('website/vidio_kategori/Tambah'),
      createRoute('survey/jawaban'),
      createRoute('survey/report'),
      createRoute('survey/analisa'),
      createRoute('survey/view', 'survey/Tambah'),
      createRoute('survey'),
      createRoute('outlet/wa_bisnis'),
      createRoute('outlet/extendtrial'),
      createRoute('sales_v2'),
      createRoute('sales_v2/Tambah'),
      createRoute('sales_v2/nonaktif'),
      createRoute('sales_v2/riwayat'),
      createRoute('sales_v2/performa'),
      createRoute('blaztap/bahan_baku'),
      createRoute('blaztap/bom'),
      createRoute('blaztap/bom/Tambah'),
      createRoute('blaztap/pembelian_bahan'),
      createRoute('blaztap/manufacture'),
      createRoute('blaztap/serial_number'),
      createRoute('blaztap/stock_product'),
      createRoute('blaztap/barang_keluar'),
      createRoute('blaztap/barang_dibawa'),
      createRoute('blaztap/order_blaztap'),
      createRoute('blaztap/laporan'),
      createRoute('blaztap/laporan_pendaftaran'),
      createRoute('blaztap_repair/return'),
      createRoute('blaztap_repair/product_return'),
      createRoute('blaztap_repair/manufacture_return'),
      createRoute('blaztap_repair/penguraian'),
      createRoute('blaztap_warranty/mesin'),
      createRoute('blaztap_warranty/diagnosa'),
      createRoute('blaztap_warranty/claim_policy'),
      createRoute('blaztap_warranty/claim_mitra'),
      createRoute('sales_v2/detailsales/[id]', 'sales_v2/detailsales'),
      createRoute('sales_v2/detailsales/[id]/[tab]', 'sales_v2/detailsales'),
      createRoute('voucher/produk/form', 'voucher/produk/Tambah'),
      createRoute('voucher/produk'),
      createRoute('support/snkmitrareseller'),
      createRoute('mitralevel/form', 'mitralevel/Tambah'),
      createRoute('mitralevel'),
      createRoute('mitrablaztap/form', 'mitrablaztap/Tambah'),
      createRoute('mitrablaztap'),
      createRoute('dropbox/getaccesscode', 'dropbox/getaccescode'),
      createRoute('dropbox'),
      createRoute('support/snkbetainstruksi'),
      createRoute('support/snkbetapendaftaran'),
      createRoute('betatester/report'),
      createRoute('betatester/bug'),
      createRoute('betatester/data/view', 'betatester/data/form'),
      createRoute('betatester/pendaftaran/view', 'betatester/pendaftaran/form'),
      createRoute('betatester/data'),
      createRoute('betatester/pendaftaran'),
      createRoute('outlet/betatester', 'betatester'),
      createRoute('outlet/trialbisnis', 'outlettrialbisnis'),
      createRoute('support/snkfreeupgrade'),
      createRoute('testt', 'event/test'),
      createRoute('transaksiratarata'),
      createRoute('nota'),

      createRoute('referensiharga'),
      createRoute('shortlink/ringkasan', 'iklan'),
      createRoute('shortlink/data', 'iklan/data'),
      createRoute('shortlink', 'iklan'),
      createRoute('feedback/bug'),
      createRoute('feedback/bugtest', 'feedback/bugtestt'),
      createRoute('feedback/vidio/form', 'feedback/vidio/Tambah'),
      createRoute('promoter/daftar-promoter/[id]', 'promoter/view'),
      createRoute('promoter/daftar-promoter/[id]/[tab]', 'promoter/view'),
      createRoute('promoter/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('promoter/view'),
      createRoute('promoter'),

      createRoute('reseller/daftar-reseller/[id]', 'reseller/view'),
      createRoute('reseller/daftar-reseller/[id]/[tab]', 'reseller/view'),
      createRoute('reseller/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('reseller/view'),
      createRoute('reseller'),
      createRoute('voucher/data/order/tambah', 'order/daftar_order/addorder'),
      createRoute('order/[id]', 'voucher/datarsl/Tambah'),
      createRoute('voucher/data/rsl', 'voucher/datarsl'),
      createRoute('voucher/approval'),
      createRoute('voucher/data/rsl/tambah', 'voucher/datarsl/addorder'),
      createRoute('voucher/laporan/pendapatan', 'voucher/laporanpendapatan'),
      createRoute('partner/suspend'),
      createRoute('partner/reject', 'partner/ditolak'),
      createRoute('partner/pendaftaran'),
      createRoute('partner/view'),
      createRoute('promospecial', 'website/specialpromo/index'),
      createRoute('penjualan/produk/retail', 'penjualan/produk/index'),
      createRoute('penjualan/produk/retail/form', 'penjualan/produk/Tambah'),
      createRoute('outletaktivasi/custom/view', 'outletaktivasi/aplikasicustom/view'),
      createRoute('outletaktivasi/custom', 'outletaktivasi/aplikasicustom/index'),
      createRoute('outletaktivasi/upgrade', 'outletaktivasi/upgrade/index'),
      createRoute('outletaktivasi/ringkasan', 'outletaktivasi/ringkasan/index'),
      createRoute('outletaktivasi/laporan', 'outletaktivasi/laporan/index'),
      createRoute('penjualan/ringkasan/view'),
      createRoute('penjualan/ringkasan/view/topkota', 'penjualan/ringkasan/view/top_kota'),
      createRoute('penjualan/ringkasan/view/topsupplier', 'penjualan/ringkasan/view/top_supplier'),
      createRoute('penjualan/ringkasan'),
      createRoute('penjualan/invoice'),
      createRoute('penjualan/data_order'),
      createRoute('penjualan/preorder'),
      createRoute('penjualan/preorder/[id]'),
      createRoute('penjualan/topproductview/view'),
      createRoute('penjualan/topproductview'),
      createRoute('penjualan/onchart/view'),
      createRoute('penjualan/onchart'),
      createRoute('penjualan/selesai/view'),
      createRoute('penjualan/selesai'),
      createRoute('penjualan/inproses/view'),
      createRoute('penjualan/inproses'),
      createRoute('penjualan/konfirmasiorder/view'),
      createRoute('penjualan/konfirmasiorder'),
      createRoute('penjualan/pendingorder/view'),
      createRoute('penjualan/pendingorder'),
      createRoute('penjualan/ongkir'),
      createRoute('penjualan/ongkir/view', 'penjualan/ongkir/Tambah'),
      createRoute('isiweb/form', 'website/isiwebsite/form'),
      createRoute('isiweb', 'website/isiwebsite/index'),
      createRoute('spesifikasilangganan/form', 'website/spesifikasilangganan/form'),
      createRoute('spesifikasilangganan', 'website/spesifikasilangganan/index'),
      createRoute('seo'),
      createRoute('outlet/laporan', 'outlet/laporan/index'),
      createRoute('outlet/bonus', 'outlet/bonus/index'),
      createRoute('outletaktivasi/publish'),
      createRoute('outletaktivasi/pembayaran'),
      createRoute('outletaktivasi/draf'),
      createRoute('sales/job/verif/riwayat', 'job/admin/verif/riwayat'),
      createRoute('sales/withdraw'),
      createRoute('partner/withdraw'),
      createRoute('sales/job/verif', 'job/admin/verif/index'),
      createRoute('sales/job', 'job/admin/index'),
      createRoute('ringkasan'),
      createRoute('setting'),
      createRoute('referal/pengaturan'),
      createRoute('referal/pengaturan/form'),
      createRoute('referal/data'),
      createRoute('referal/data/detail'),
      createRoute('referal/pemakaian'),
      createRoute('poin'),
      createRoute('poin/pengaturan'),
      createRoute('poin/riwayat'),
      createRoute('poin/outlet'),
      createRoute('poin/outlet/[id]'),
      createRoute('confiq'),
      createRoute('confiq/form'),
      createRoute('promo'),
      createRoute('promo/detail'),
      createRoute('promo/data'),
      createRoute('promo/data/form'),
      createRoute('qris/aktivasi'),
      createRoute('outletaktivasi'),
      createRoute('jadwaltraining'),
      createRoute('jadwaltraining/trainingvirtual'),
      createRoute('jadwaltraining/trainingonlocation'),
      createRoute('jadwaltraining/ringkasan'),
      createRoute('prospek'),
      createRoute('prospek/sukses'),
      createRoute('prospek/batch'),
      createRoute('prospek/ringkasan'),
      createRoute('prospek_new'),
      createRoute('prospek_new/sukses'),
      createRoute('prospek_new/batch'),
      createRoute('prospek_new/ringkasan'),
      createRoute('prospek_new/klaim'),
      createRoute('prospek_new/performa_sales'),
      createRoute('prospek_new/performa_cs'),
      createRoute('withdrawal'),
      createRoute('withdrawal/proses'),
      createRoute('withdrawal/sukses'),
      createRoute('withdrawal/batal'),
      createRoute('event'),
      createRoute('event/[id]', 'event/Tambah'),
      createRoute('prospek/ringkasan/detail', 'prospek/ringkasan/Detail'),
      createRoute('prospek_new/ringkasan/detail', 'prospek_new/ringkasan/Detail'),
      createRoute('jadwaltraining/form', 'jadwaltraining/Tambah'),
      createRoute('jadwaltraining/selesai'),
      createRoute('jadwaltraining/dibatalkan'),
      createRoute('partner/form', 'partner/Tambah'),
      createRoute('partner', 'partner/index'),
      createRoute('partner/saldo'),
      createRoute('partner/saldo/riwayat', 'partner/riwayat'),
      createRoute('partner/saldo/view'),
      createRoute('partner/saldo/benefit', 'sales/bonus'),
      createRoute('voucher/detail', 'voucher/ringkasan/detail'),
      createRoute('voucher/ringkasan'),
      createRoute('outletaktivasi/view'),
      // createRoute('feedback/bug/kanban'),
      createRoute('profil'),
      createRoute('voucher/laporan'),
      createRoute('test'),
      createRoute('sales/saldo/riwayat', 'sales/riwayat'),
      createRoute('sales/saldo/view'),
      createRoute('sales/saldo/benefit', 'sales/bonus'),
      createRoute('sales/saldo'),
      createRoute('sales/datareferal'),
      createRoute('sales/progress/detail'),
      createRoute('sales/kunjungan/form', 'sales/kunjungan/Tambah'),
      createRoute('sales/progress'),
      createRoute('sales/reject', 'sales/ditolak'),
      createRoute('sales/suspend'),
      createRoute('sales/pendaftaran'),
      createRoute('dashboard'),
      createRoute('banner'),
      createRoute('banner/form', 'banner/Tambah'),
      createRoute('banner/promosi'),
      createRoute('banner/promosi/form', 'banner/promosi/Tambah'),
      createRoute('promo', 'promo/data'),
      createRoute('promo/form', 'promo/data/form'),
      createRoute('feedback/testimoni'),
      // createRoute('feedback/bug/form', 'feedback/bug/Tambah'),
      // createRoute('feedback/bug/detail', 'feedback/bug/Detail'),
      // createRoute('feedback/bug/tambah', 'feedback/bug/TambahDetail'),
      // createRoute('feedback/bug'),
      createRoute('sales'),
      createRoute('sales/view'),
      createRoute('sales/form', 'sales/Tambah'),
      createRoute('user'),
      createRoute('user/form', 'user/Tambah'),
      createRoute('produk/kategori'),
      createRoute('blog/kategori'),
      createRoute('produk/kategori/form', 'produk/kategori/Tambah'),
      createRoute('blog/kategori/form', 'blog/kategori/Tambah'),
      createRoute('blog/subkategori', 'blog/sub_kategori'),
      createRoute('blog/subkategori/form', 'blog/sub_kategori/Tambah'),
      createRoute('blog/post'),
      createRoute('blog/post/form', 'blog/post/Tambah'),
      createRoute('blog/review'),
      createRoute('produk/varian'),
      createRoute('produk/review'),
      createRoute('produk/varian/form', 'produk/varian/Tambah'),
      createRoute('produk/sku'),
      createRoute('produk/sku/form', 'produk/sku/Tambah'),
      createRoute('feedback/testimoni/form', 'feedback/testimoni/Tambah'),
      createRoute('feedback/masukkan'),
      createRoute('feedback/masukkan/form', 'feedback/masukkan/Tambah'),
      createRoute('support/faq'),
      createRoute('support/faq/form', 'support/faq/Tambah'),
      createRoute('support/help'),
      createRoute('support/help/form', 'support/help/Tambah'),
      createRoute('support/toc'),
      createRoute('support/privacy', 'support/pp'),
      createRoute('support/snkref'),
      createRoute('support/snkcustom'),

      createRoute('support/snkrefoutlet'),
      {
        path: '/livechat',
        exact: true,
        component: () => <Redirect to="/livechat/none" />
      },
      createRoute('livechat/[room]', 'livechat'),
      createRoute('daftar_order', 'order/daftar_order/index'),
      createRoute('daftar_order/[id]', 'order/daftar_order/Tambah'),
      createRoute('laporan_order', 'order/laporan_order/index'),
      createRoute('ringkasan_order', 'order/ringkasan_order/index'),
      createRoute('ringkasan_order/detail', 'order/ringkasan_order/info'),
      createRoute('repeat_order', 'order/repeat_order/index'),
      createRoute('xendit_status', 'order/xendit_status/index'),
      createRoute('repeat_order/[id]/detail', 'order/repeat_order/info'),
      createRoute('ringkasan_order/[id]/info', 'promo/detail'),
      createRoute('outlet/daftar-outlet', 'outlet'),
      createRoute('outlet/antrian-outlet', 'outlet/antrian_outlet'),

      createRoute('outlet/daftar-outlet/[id]/[tab]', 'outlet/Tambah'),
      createRoute('outlet/daftar-outlet/[id]/[tab]/[id]', 'outlet/transaksi/InfoTransaksi'),
      createRoute('outlet/owner', 'owner'),
      createRoute('outlet/owner/[id]/detail', 'owner/DetailOwner'),
      createRoute('outlet/profil-outlet/[id]', 'outlet/detailOutlet'),
      createRoute('outlet/outlet-upgrade', 'outletupgrade'),
      createRoute('outlet/outlet-archive/[id]', 'outletarchive/detailarchive'),
      createRoute('outlet/outlet-archive', 'outletarchive'),
      createRoute('outlet/ringkasan-outlet', 'outlet/ringkasan_outlet/index'),
      createRoute('outlet/ringkasan-outlet/[id]/detail', 'outlet/detailOutlet'),
      createRoute('outlet/ringkasan-outlet/Info', 'outlet/ringkasan_outlet/InfoOutlet'),
      createRoute('outlet/outlet-aktif', 'outlet/pertumbuhan_outlet'),
      createRoute('broadcast/wa'),
      createRoute('broadcast/template'),
      createRoute('broadcast/template/tambah', 'broadcast/buatTemplate'),
      createRoute('broadcast/wa/tambah', 'broadcast/buatBroadcast'),
      createRoute('broadcast/koneksi'),
      createRoute('broadcast'),
      createRoute('broadcast/form', 'broadcast/Tambah'),
      createRoute('autobroadcast'),
      createRoute('autobroadcast/form', 'autobroadcast/Tambah'),
      createRoute('images'),
      createRoute('voucher/pembuatan'),
      createRoute('voucher/request'),
      createRoute('voucher/pembuatan/form', 'voucher/pembuatan/Tambah'),
      createRoute('voucher/pembuatan/detail', 'voucher/pembuatan/Detail'),
      createRoute('voucher/data'),
      createRoute('voucher/pemakaian'),
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

function createRoute(path, importPath) {
  const mypath = '/' + path.split('[').join(':').split(']').join('');
  const viewPath = importPath || path;

  return {
    path: mypath,
    exact: true,
    component: lazy(() => import('views/' + viewPath))
  }
}

routes.propTypes = {
  settoggleDark: PropTypes.bool,
  toggleDark: PropTypes.bool
};

export default routes;
